export default "__VITE_ASSET__56fc7203__"